export default function Go_Bitwise () {
  return (
    <div>
      <h1>Go_Bitwise </h1>
      <p>Bitwise</p>
    </div>
  );
}